import axiosInstance from '@/services/apiService';

// Define the endpoint for user registration
const REGISTER_ENDPOINT = '/auth/register';

/**
 * Function to register a new user by calling the /api/auth/register endpoint.
 * This function uses RegistrationDTO to send the registration request.
 *
 * @param {Object} registrationData - The user data to register (e.g., username, email, password).
 * @returns {Promise<Object>} - The response containing the UserDto.
 */
const registerUser = async (registrationData) => {
    try {
        const response = await axiosInstance.post(REGISTER_ENDPOINT, registrationData);
        return response.data;
    } catch (error) {
        console.error('Registration failed:', error);
        throw error;
    }
};

export default {
    registerUser,
};